module.exports = __webpack_public_path__ + "img/arrow_backward.1c601dd8.svg";